import { Cloud, Home, Shield, Sync } from '@mui/icons-material';
import { lazy } from 'react';
import { Permissions } from 'services/enums';
import { DEFAULT_ROUTE, IRouteProps } from '../types';

const DefensePages = lazy(() => import('pages/DefensePages'));
const HomeAssistantPage = lazy(() => import('pages/HomeAssistantPage'));
const IntegrationPage = lazy(() => import('pages/IntegrationPage'));
const SyncStatusPage = lazy(() => import('pages/SyncStatusPage'));

export const integrationsRoutes: IRouteProps[] = [
	{
		type: 'collapse',
		name: 'Integrações e IA',
		key: 'integrations-management',
		icon: <Cloud />,
		protected: true,
		collapse: [
			{
				type: 'collapse',
				name: 'routersNames.integrationsPage',
				key: 'integracao',
				icon: <Cloud />,
				permissionId: Permissions.INTEGRATIONS,
				route: `${DEFAULT_ROUTE}/integrations`,
				component: <IntegrationPage />,
				protected: true,
			},
			{
				type: 'collapse',
				name: 'routersNames.homeAssistant',
				key: 'home-assistant',
				icon: <Home />,
				permissionId: Permissions.HOME_ASSISTANT_DEVICE,
				route: `${DEFAULT_ROUTE}/home-assistant`,
				component: <HomeAssistantPage />,
				protected: true,
			},
			{
				type: 'collapse',
				name: 'routersNames.syncStatus',
				key: 'sync-status',
				icon: <Sync />,
				permissionId: { any: [Permissions.INTEGRATIONS, Permissions.FACE_REGISTER] },
				route: `${DEFAULT_ROUTE}/sync-status`,
				component: <SyncStatusPage />,
				protected: true,
			},
			{
				type: 'collapse',
				name: 'DefenseIA',
				key: 'defense',
				isDisabled: false,
				icon: <Shield />,
				permissionId: Permissions.DEFENSE_INTEGRATION,
				route: `${DEFAULT_ROUTE}/defense`,
				component: <DefensePages />,
				protected: true,
			},
		],
	},
];
